import {Observable, of} from 'rxjs';
import {Injectable, InjectionToken} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError} from 'rxjs/operators';

import { ApiRoutes } from '../../../../common/api-routes';


export interface IStartcardImportService {
  ImportStartcards(projectId: string, clientId?: string): Observable<boolean>;
  ImportStartcard(projectId: string, startcardId: string): Observable<boolean>;
  ImportSelectedStartcards(projectId: string, selectedStartcardsIds: string[]): Observable<boolean>;
}

export const StartcardImportToken = new InjectionToken<IStartcardImportService>('IStartcardImportService');

@Injectable({
  providedIn: 'root'
})
export abstract class BaseStartcardImportService implements IStartcardImportService {
  constructor(protected http: HttpClient) {}

  abstract ImportStartcards(projectId: string, clientId?: string): Observable<boolean>;

  ImportStartcard(projectId: string, startcardId: string): Observable<boolean> {
    return this.http.post<boolean>(`${ApiRoutes.Startcards}/projects/${projectId}/startcards/${startcardId}/importStartcard`, {})
      .pipe(catchError(() => of(true)));
  }

  ImportSelectedStartcards(projectId: string, selectedStartcardsIds: string[]): Observable<boolean> {
    return this.http.post<boolean>(`${ApiRoutes.Startcards}/projects/${projectId}/importSelectedStartcards`, selectedStartcardsIds )
      .pipe(catchError(() => of(true)));
  }
}

@Injectable({
  providedIn: 'root'
})
export class UsaStartcardImportService extends BaseStartcardImportService {

  ImportStartcards(projectId: string, clientId?: string): Observable<boolean> {
    return this.http.post<boolean>(`${ApiRoutes.Startcards}/projects/${projectId}/importStartcards`, {})
      .pipe(catchError(() => of(true)));
  }
}

@Injectable({
  providedIn: 'root'
})
export class UkStartcardImportService extends BaseStartcardImportService {

  ImportStartcards(projectId: string, clientId?: string): Observable<boolean> {
    return this.http.post<boolean>(`${ApiRoutes.Startcards}/region/uk/project/${projectId}/clientId/${clientId}/importStartcards`, {})
      .pipe(catchError(() => of(true)));
  }
}
